import { useState } from 'react';

export default function useModal() {
  const [closeConfirmModalIsOpen, setCloseConfirmModalIsOpen] = useState<boolean>(false);
  return { closeConfirmModalIsOpen, setCloseConfirmModalIsOpen };
}
